import request from '../utils/request'

const api = {
   getUsdtIndex:"getUsdtIndex",
  addUsdtState:"addUsdtState",
  addUsdtState1:"addUsdtState1",
  login: 'login',
  register:"register",
  getTuanInfo:"getTuanInfo",
  getLpInfo:"getLpInfo",
  getNodeIndex:"getNodeIndex",
   getIdoInfo:"getIdoInfo",
   getTaskIndex:"getTaskIndex",
   getQianIndex:"getQianIndex",
   addIdoBnb:"addIdoBnb",
   addQian:"addQian",
   addIdoJie:"addIdoJie",
  getPledgeIndex:"getPledgeIndex",
   getGameIndex:"getGameIndex",

   getGameIndex1:"getGameIndex1",
   getGameIndex160:"getGameIndex160",
    getGameIndex2:"getGameIndex2",
    getGameHis:"getGameHis",
  getPledgeCcerIndex:"getPledgeCcerIndex",
  getNftIndex:"getNftIndex",
  getDepositIndex:"getDepositIndex",
  getNodeCanBuy:"getNodeCanBuy",
  getPledgeCanBuy:"getPledgeCanBuy",
  addNodeBuy:"addNodeBuy",
  addPledgeBuy:"addPledgeBuy",
   addPledgeLp:"addPledgeLp",
  addBox:"addBox",
addApprove:"addApprove",
  
  addHero:"addHero",
  addRed:"addRed",
  addBattle:"addBattle",
  addPledgeBuy1:"addPledgeBuy1",
  addPet1:"addPet1",
   rePet1:"rePet1",
   addPet2:"addPet2",
  unPledgeBuy1:"unPledgeBuy1",
  unPledgeBuy:"unPledgeBuy",
  addDepositBuy:"addDepositBuy",
  addDepositBuyRed:"addDepositBuyRed",
  getSwapIndex:"getSwapIndex",
  addSwap:"addSwap",
  addSwap1:"addSwap1",
  getTixianIndex:"getTixianIndex",
  getAssetsIndex:"getAssetsIndex",
  gethasPay:"gethasPay",
  getBoxIndex:"getBoxIndex",
  getBuyHeroIndex:"getBuyHeroIndex",
  getHeroIndex:"getHeroIndex",
  getBossIndex:"getBossIndex",

  getTixianRecord:"getTixianRecord",
  getBoxRecord:"getBoxRecord",
  getSwapRecord:"getSwapRecord",
  getBoxRate:"getBoxRate",
  addTixian:"addTixian",
   addPayBnb:"addPayBnb",
  
  getLiushui:"getLiushui",
  getLiushuiUsdt:"getLiushuiUsdt",
  getLiushuiMarsx:"getLiushuiMarsx",
  getLiushuiMeba:"getLiushuiMeba",
  getLiushuiEth:"getLiushuiEth",
  getLiushuiSpacexMint:"getLiushuiSpacexMint",
  getLiushuiDogePledge:"getLiushuiDogePledge",
  getLiushuiEthLock:"getLiushuiEthLock",
  getUserInfo:"getUserInfo",
  getMarketIndex:"getMarketIndex",
  getIsQian:"getIsQian",
  getUpHeroIndex:"getUpHeroIndex",
  getUpNeedHero:"getUpNeedHero",
  addUpHero:"addUpHero",
  getTrMyHeroIndex:"getTrMyHeroIndex",
  addSell:"addSell",
  cancelSell:"cancelSell",
  getTrIndex:"getTrIndex",
  addTrBuy:"addTrBuy",
  getNonce:"getNonce",
}

export default api

export const getNonce = (parameter) => {
 return request({
    url: api.getNonce,
    method: 'post',
    data: parameter,
    showLoading:false
  })
}

export const getUsdtIndex = (parameter) => {
  return request({
    url: api.getUsdtIndex,
    method: 'get',
    params: parameter,
    showLoading:true,
  })
}

export const addUsdtState = (parameter) => {
  return request({
    url: api.addUsdtState,
    method: 'post',
    data: parameter
  })
}

export const addUsdtState1 = (parameter) => {
  return request({
    url: api.addUsdtState1,
    method: 'post',
    data: parameter
  })
}

export const addTrBuy = (parameter) => {
  return request({
    url: api.addTrBuy,
    method: 'post',
    data: parameter
  })
}

export const getTrIndex = (parameter) => {
  return request({
    url: api.getTrIndex,
    method: 'post',
    data: parameter
  })
}

export const cancelSell = (parameter) => {
  return request({
    url: api.cancelSell,
    method: 'post',
    data: parameter
  })
}

export const addSell = (parameter) => {
  return request({
    url: api.addSell,
    method: 'post',
    data: parameter
  })
}

export const addUpHero = (parameter) => {
  return request({
    url: api.addUpHero,
    method: 'post',
    data: parameter
  })
}

export const getUpNeedHero = (parameter) => {
  return request({
    url: api.getUpNeedHero,
    method: 'post',
    data: parameter
  })
}

export const getTrMyHeroIndex = (parameter) => {
  return request({
    url: api.getTrMyHeroIndex,
    method: 'post',
    data: parameter
  })
}

export const getUpHeroIndex = (parameter) => {
  return request({
    url: api.getUpHeroIndex,
    method: 'get',
    params: parameter
  })
}

export const getIsQian = (parameter) => {
  return request({
    url: api.getIsQian,
    method: 'post',
    data: parameter
  })
}

export const addTixian = (parameter) => {
  return request({
    url: api.addTixian,
    method: 'post',
    data: parameter
  })
}

export const addPayBnb = (parameter) => {
  return request({
    url: api.addPayBnb,
    method: 'post',
    data: parameter
  })
}

export const addSwap = (parameter) => {
  return request({
    url: api.addSwap,
    method: 'post',
    data: parameter
  })
}
export const addQian = (parameter) => {
  return request({
    url: api.addQian,
    method: 'post',
    data: parameter
  })
}
export const addSwap1 = (parameter) => {
  return request({
    url: api.addSwap1,
    method: 'post',
    data: parameter
  })
}
export const addNodeBuy = (parameter) => {
  return request({
    url: api.addNodeBuy,
    method: 'post',
    data: parameter
  })
}

export const addPledgeBuy = (parameter) => {
  return request({
    url: api.addPledgeBuy,
    method: 'post',
    data: parameter
  })
}

export const addPledgeLp = (parameter) => {
  return request({
    url: api.addPledgeLp,
    method: 'post',
    data: parameter
  })
}

export const addPet1 = (parameter) => {
  return request({
    url: api.addPet1,
    method: 'post',
    data: parameter
  })
}

export const rePet1 = (parameter) => {
  return request({
    url: api.rePet1,
    method: 'post',
    data: parameter
  })
}

export const addPet2 = (parameter) => {
  return request({
    url: api.addPet2,
    method: 'post',
    data: parameter
  })
}

export const addBox = (parameter) => {
  return request({
    url: api.addBox,
    method: 'post',
    data: parameter
  })
}

export const addApprove = (parameter) => {
  return request({
    url: api.addApprove,
    method: 'post',
    data: parameter
  })
}

export const addHero = (parameter) => {
  return request({
    url: api.addHero,
    method: 'post',
    data: parameter
  })
}

export const addRed = (parameter) => {
  return request({
    url: api.addRed,
    method: 'post',
    data: parameter
  })
}

export const addIdoBnb = (parameter) => {
  return request({
    url: api.addIdoBnb,
    method: 'post',
    data: parameter
  })
}



export const addIdoJie = (parameter) => {
  return request({
    url: api.addIdoJie,
    method: 'post',
    data: parameter
  })
}


export const addBattle = (parameter) => {
  return request({
    url: api.addBattle,
    method: 'post',
    data: parameter
  })
}

export const addPledgeBuy1 = (parameter) => {
  return request({
    url: api.addPledgeBuy1,
    method: 'post',
    data: parameter
  })
}

export const unPledgeBuy1 = (parameter) => {
  return request({
    url: api.unPledgeBuy1,
    method: 'post',
    data: parameter
  })
}

export const unPledgeBuy = (parameter) => {
  return request({
    url: api.unPledgeBuy,
    method: 'post',
    data: parameter
  })
}

export const addDepositBuy = (parameter) => {
  return request({
    url: api.addDepositBuy,
    method: 'post',
    data: parameter
  })
}

export const addDepositBuyRed = (parameter) => {
  return request({
    url: api.addDepositBuyRed,
    method: 'post',
    data: parameter
  })
}

export const getTixianIndex = (parameter) => {
  return request({
    url: api.getTixianIndex,
    method: 'post',
    data: parameter
  })
}

export const getAssetsIndex = (parameter) => {
  return request({
    url: api.getAssetsIndex,
    method: 'post',
    data: parameter
  })
}

export const gethasPay = (parameter) => {
  return request({
    url: api.gethasPay,
    method: 'post',
    data: parameter
  })
}

export const getQianIndex = (parameter) => {
  return request({
    url: api.getQianIndex,
    method: 'get',
    params: parameter
  })
}


export const getBoxIndex = (parameter) => {
  return request({
    url: api.getBoxIndex,
    method: 'get',
    params: parameter
  })
}

export const getBuyHeroIndex = (parameter) => {
  return request({
    url: api.getBuyHeroIndex,
    method: 'get',
    params: parameter
  })
}

export const getHeroIndex = (parameter) => {
  return request({
    url: api.getHeroIndex,
    method: 'post',
    data: parameter
  })
}

export const getBossIndex = (parameter) => {
  return request({
    url: api.getBossIndex,
    method: 'get',
    params: parameter
  })
}


export const getTixianRecord = (parameter) => {
  return request({
    url: api.getTixianRecord,
    method: 'post',
    data: parameter
  })
}

export const getBoxRecord = (parameter) => {
  return request({
    url: api.getBoxRecord,
    method: 'get',
    params: parameter
  })
}

export const getSwapRecord = (parameter) => {
  return request({
    url: api.getSwapRecord,
    method: 'get',
    params: parameter
  })
}

export const getBoxRate = (parameter) => {
  return request({
    url: api.getBoxRate,
    method: 'get',
    params: parameter
  })
}

export const getUserInfo = (parameter) => {
  return request({
    url: api.getUserInfo,
    method: 'get',
    params: parameter
  })
}

export const getLiushuiUsdt = (parameter) => {
  return request({
    url: api.getLiushuiUsdt,
    method: 'post',
    data: parameter
  })
}

export const getLiushui = (parameter) => {
  return request({
    url: api.getLiushui,
    method: 'post',
    data: parameter
  })
}

export const getLiushuiMarsx = (parameter) => {
  return request({
    url: api.getLiushuiMarsx,
    method: 'post',
    data: parameter
  })
}

export const getLiushuiMeba = (parameter) => {
  return request({
    url: api.getLiushuiMeba,
    method: 'post',
    data: parameter
  })
}

export const getLiushuiSpacexMint = (parameter) => {
  return request({
    url: api.getLiushuiSpacexMint,
    method: 'post',
    data: parameter
  })
}

export const getLiushuiDogePledge = (parameter) => {
  return request({
    url: api.getLiushuiDogePledge,
    method: 'post',
    data: parameter
  })
}

export const getLiushuiEth = (parameter) => {
  return request({
    url: api.getLiushuiEth,
    method: 'post',
    data: parameter
  })
}

export const getLiushuiEthLock = (parameter) => {
  return request({
    url: api.getLiushuiEthLock,
    method: 'post',
    data: parameter
  })
}

export const getSwapIndex = (parameter) => {
  return request({
    url: api.getSwapIndex,
    method: 'get',
    params: parameter
  })
}
export const getNodeCanBuy = (parameter) => {
  return request({
    url: api.getNodeCanBuy,
    method: 'get',
    params: parameter
  })
}

export const getPledgeCanBuy = (parameter) => {
  return request({
    url: api.getPledgeCanBuy,
    method: 'get',
    params: parameter
  })
}


export const getNodeIndex = (parameter) => {
  return request({
    url: api.getNodeIndex,
    method: 'get',
    params: parameter
  })
}

export const getPledgeIndex = (parameter) => {
  return request({
    url: api.getPledgeIndex,
    method: 'get',
    params: parameter
  })
}





export const getGameIndex = (parameter) => {
  return request({
    url: api.getGameIndex,
    method: 'get',
    params: parameter,
    showLoading:false,
  })
}

export const getGameIndex1 = (parameter) => {
  return request({
    url: api.getGameIndex1,
    method: 'get',
    params: parameter,
    showLoading:false,
  })
}

export const getGameIndex160 = (parameter) => {
  return request({
    url: api.getGameIndex160,
    method: 'get',
    params: parameter,
    showLoading:false,
  })
}

export const getGameHis = (parameter) => {
  return request({
    url: api.getGameHis,
    method: 'get',
    params: parameter,
    showLoading:false,
  })
}

export const getGameIndex2 = (parameter) => {
  return request({
    url: api.getGameIndex2,
    method: 'get',
    params: parameter
  })
}



export const getPledgeCcerIndex = (parameter) => {
  return request({
    url: api.getPledgeCcerIndex,
    method: 'get',
    params: parameter
  })
}

export const getNftIndex = (parameter) => {
  return request({
    url: api.getNftIndex,
    method: 'get',
    params: parameter
  })
}

export const getMarketIndex = (parameter) => {
  return request({
    url: api.getMarketIndex,
    method: 'get',
    params: parameter
  })
}
export const getDepositIndex = (parameter) => {
  return request({
    url: api.getDepositIndex,
    method: 'get',
    params: parameter
  })
}
export const getTuanInfo = (parameter) => {
  return request({
    url: api.getTuanInfo,
    method: 'get',
    params: parameter
  })
}

export const getLpInfo = (parameter) => {
  return request({
    url: api.getLpInfo,
    method: 'get',
    params: parameter
  })
}

export const getIdoInfo = (parameter) => {
  return request({
    url: api.getIdoInfo,
    method: 'get',
    params: parameter
  })
}

export const getTaskIndex = (parameter) => {
  return request({
    url: api.getTaskIndex,
    method: 'get',
    params: parameter
  })
}



export const register = (parameter) => {
  return request({
    url: api.register,
    method: 'post',
    data: parameter
  })
}

export const login = (parameter) => {
    return request({
      url: api.login,
      method: 'post',
      data: parameter
    })
  }


 